import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/RecruiterSuccess.css";

const RecruiterSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">✔️</div>
        <h2>Congratulations</h2>
        <p>Your recruiter account has been created successfully!</p>
        <p>Go ahead and explore our range of hiring plans.</p>
        <button className="explore-btn" onClick={() => navigate("/plans")}>
          Explore Plans
        </button>
      </div>
    </div>
  );
};

export default RecruiterSuccess;
